import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import "./ProgramRibbon.css"

export const ProgramRibbon = ({ onRunProgram, onStopProgram, onNextStep, showProgramModal, showScheduleModal, isRunning = false }) => {
    const { t } = useTranslation()

    return (
        <div className="ribbon">
            {isRunning ? (
                <Flex gap="middle">
                    <Button onClick={onNextStep} type="primary">
                        {t("page.card-details.program-list.program.button.next-step")}
                    </Button>
                    <Button onClick={onStopProgram} danger>
                        {t("page.card-details.program-list.program.button.cancel")}
                    </Button>
                </Flex>
            ) : (
                <Button onClick={onRunProgram} type="primary">
                    {t("page.card-details.program-list.program.button.run")}
                </Button>
            )}
        </div>
    )
}

export default ProgramRibbon
